<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" :loading="loading" :width="610">
      <h3 slot="header" class="modal-header">用户详情</h3>
      <div class="content" v-if="formData">

        <div>姓名：<span class="info">{{formData.nickName || ''}}</span></div>
        <div>手机号：<span class="info">{{formData.phone || ''}}</span></div>
        <div>性别：<span class="info">{{formData.sex == 1 ? '男': '女'}}</span></div>
        <div>邮箱：<span class="info">{{formData.email || ''}}</span></div>
        <div>职位：<span class="info">{{formData.positionName || ''}}</span></div>
        <div>所属机构：<span class="info">{{titleArr}}</span></div>
        <div>所属角色：<span class="info">{{roleNameArr}}</span></div>
        <div>备注：<span class="info">{{formData.remark || ''}}</span></div>

      </div>
      <div slot="footer">
        <div>
          <Button type="primary" size="large" @click="close">确定</Button>
        </div>
      </div>
    </Modal>
  </div>


</template>
<script>
  import AddOrg from './AddOrg'
  import CharacterList from './CharacterList'
  import {addUser, getUserDetail, updateUser} from "../../../../api/user";

  export default {
    name: "",
    components: {
      AddOrg,
      CharacterList
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      checkUid: {
        type: String,
        default: ''
      },
    },
    watch: {
      n() {
        this.clearData()
        this.isShow = true
        this.initData(this.checkUid)
      }
    },
    data() {
      return {
        titleArr: "",
        roleNameArr: "",
        loading: true,
        isShow: false,
        formData: null
      }
    },
    methods: {
      close() {
        this.isShow = false
      },
      clearData() {
        this.formData = null
        this.titleArr = ""
        this.roleNameArr = ""
      },
      initData(checkUid) {
        if (checkUid) {
          getUserDetail({uid: checkUid}).then(res => {
            if (!res.data) {
              return
            }
            this.formData = res.data
            res.data.organNames && (this.titleArr = res.data.organNames.join(','))
            res.data.roleNames && (this.roleNameArr = res.data.roleNames.join(','))
          }).catch(res => {
          }).finally(() => {
            this.loading = false
          })
        }
      },
    }

  }
</script>

<style scoped>
  .item-width {
    width: 280px;
  }

  .info {
    padding-left: 8px;
    font-weight: 600;
  }

  .content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    /*margin: 0 auto;*/
  }

  .content div {
    width: 50%;
    flex: none;
    margin-bottom: 16px;

  }

</style>
